import { HashLink as Link } from 'react-router-hash-link';
import { NavLink } from 'react-router-dom';
import { useStore } from "../../app/stores/store";
import { observer } from 'mobx-react-lite';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LoginRegister from '../Modals/Login&Register';
import logoPixel from '../../images/logo_inap_guatemala_mobile_pixel.png';
import loginPlaceholder from '../../images/image_placeholder.png';
import './Navbar.css';
import { ImSwitch } from "react-icons/im";
import { IoIosGitNetwork } from "react-icons/io";
import { CgDanger } from "react-icons/cg";
import { IoPersonCircleOutline, IoPersonAddOutline } from "react-icons/io5";
import { FiSettings } from "react-icons/fi";
import { GrUserSettings } from "react-icons/gr";
import Nav from 'react-bootstrap/Nav';
import Image from 'react-bootstrap/Image';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import NavDropdown from 'react-bootstrap/NavDropdown';
import LoginForm from '../../features/users/LoginForm';
import clearCache from '../Portafolio/helpers/clearCache';

function NavbarHeader() {
    const pathArray = window.location.pathname.split("/");
    const peten = "peten";
    const delegacionCentral = "/";
    const delegacionPeten = "/peten/";
    const delegacion = pathArray.includes(peten) ? (delegacionPeten) : (delegacionCentral);
    const { userStore: { user, logout, isLoggedIn, roles }, SGPersonaStore: { SGPersonaByName, loadSGPersona }, modalStore } = useStore();
    const [permiso, setPermiso] = useState<string[]>([]);
    const location = useLocation();

    // Cargar roles de usuario al iniciar sesión
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const userRoles = await roles(); // Asegúrate de que `roles()` retorna una promesa.
                if (userRoles) {
                    setPermiso(userRoles);
                }
            } catch (error) {
                console.error("Error fetching roles:", error);
            }
        };

        // Cargar roles si el usuario está logueado
        if (isLoggedIn) {
            fetchRoles();
        }
    }, [isLoggedIn, roles]);

    return (
        <>
            <Navbar collapseOnSelect expand="lg" bg="ligth" variant="light">
                <Container>
                   {/* <Navbar.Brand className='logo_area'>
                        <Nav.Link href='/'>
                            <img
                                src={logoPixel}
                                width="50"
                                height="50"
                                className="d-inline-block align-top"
                                alt="Instituto Nacional de Administración Pública INAP | Guatemala | INAP Guatemala logo"
                            />
                        </Nav.Link>
                    </Navbar.Brand>*/}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav" className='home_principal_menu'>
                        <Nav className="me-auto">
                            {/* Enlaces estáticos siempre visibles */}
                            <span className='menu_link_container'>
                                <Nav.Link key="Inicio" className='nav-link principal_menu_link' target={'_blank'} href={"https://inap.gob.gt/app/"}>Inicio</Nav.Link>
                            </span>
                            
                            <span className='menu_link_container'>
                                <Nav.Link key="Aula" target="_blank" href="https://aulavirtual.inap.gob.gt/ingreso/" className='principal_menu_link' data-text="Aula Virtual">Aula Virtual</Nav.Link>
                            </span>

                            {/* Menú desplegable visible siempre */}
                            <span className='menu_drop_down_secondary'>
                                <NavDropdown className='' title="Agenda de Servicios" id="collasible-nav-dropdown" onClick={() => { document.body.click() }} data-text="Agenda de Servicios">
                                    <span className='menu_link_container_drop'><Link key="Investigacion" className='nav-link secondary_menu_link' to={`${delegacion}asesorias`} data-text="Investigación, Asesoria y Asistencia Técnica" >Investigación, Asesoria y Asistencia Técnica</Link></span>
                                    <span className='menu_link_container_drop'><Link key="Certificacion" className='nav-link secondary_menu_link' to={`${delegacion}certificaciones`} data-text="Certificaciones" >Certificaciones</Link></span>
                                    <span className='menu_link_container_drop'><Link key="Cursos" className='nav-link secondary_menu_link' to={`${delegacion}cursos`} data-text="Cursos">Cursos y Diplomados</Link></span>
                                    <span className='menu_link_container_drop'><Link key="Posgrados" className='nav-link secondary_menu_link' to={`${delegacion}posgrados`} data-text="Posgrados">Postgrados</Link></span>
                                </NavDropdown>
                            </span>

                            <span className='menu_link_container'>
                                <Nav.Link key="Portal" className='nav-link principal_menu_link' target={'_blank'} href={"https://inap.gob.gt/web/"}>Portal Institucional</Nav.Link>
                            </span>
                        </Nav>

                        {/* Menú de usuario */}
                        <Nav className='nav_dere'>
                            <Image roundedCircle src={user?.image || loginPlaceholder} />
                            {isLoggedIn ? (
                                <NavDropdown key="name" title={user?.displayName.split(' ').slice(0, -2).join(' ')} id="collasible-nav-dropdown" onClick={() => { document.body.click() }}>
                                    <Link key="mi-perfil" className='nav-link' to={`/home/profile/editar/${user?.id}`} > <IoPersonCircleOutline /><p>Mi Perfil</p></Link>
                                    <NavDropdown.Divider />

                                    {/* Condicionales para mostrar menús según los permisos */}
                                    {permiso.includes("Operaciones") && (
                                        <>
                                            <Link className='nav-link' to={`/home/operaciones/${user?.userName}`} > <IoIosGitNetwork /><p>Operaciones</p></Link>
                                            <NavDropdown.Divider />
                                            <Link className='nav-link' to={`/configuracion/${user?.userName}`} ><FiSettings /><p>Configuración</p></Link>
                                            <NavDropdown.Divider />
                                            <Link className='nav-link enlaceTFinanciero' to={"/perfil-institucional/"}> <IoPersonAddOutline /> <p>Perfil Institucional</p> </Link>
                                            <NavDropdown.Divider />
                                            <Link className='nav-link' to={"/financiero/convenios/"}> <IoPersonAddOutline /> <p>Perfil Financiero</p> </Link>
                                            <NavDropdown.Divider />
                                            <Link className='nav-link admi-exclusive-link' to={""} onClick={clearCache}> <CgDanger /><p>Borrar Caché</p></Link>
                                        </>
                                    )}

                                    {permiso.includes("Reporte Docentes") && (
                                        <Link className='nav-link' to={`/home/operaciones/${user?.userName}`} > <IoIosGitNetwork /><p>Operaciones</p></Link>
                                    )}

                                    {permiso.includes("Perfil Institucional") && (
                                        <Link className='nav-link enlaceTFinanciero' to={"/perfil-institucional/"}> <IoPersonAddOutline /> <p>Perfil Institucional</p> </Link>
                                    )}

                                    {permiso.includes("Aplicar Pago") && (
                                        <Link className='nav-link' to={"/financiero/convenios/"}> <IoPersonAddOutline /> <p>Perfil Financiero</p> </Link>
                                    )}
                                    
                                    <NavDropdown.Divider />
                                    <Link className='nav-link' to={"/"} onClick={logout}> <ImSwitch /><p>Cerrar Sesión</p></Link>
                                </NavDropdown>
                            ) : (
                                <Nav.Link onClick={() => {
                                    localStorage.removeItem('check');
                                    localStorage.setItem('check', "false");
                                    modalStore.openModal(<LoginForm />, "tiny")
                                }}> Iniciar Sesión </Nav.Link>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default observer(NavbarHeader);
